import ResourceBudgetAPI from "../../../api/resourceBudget"
import MetricAPI from "../../../api/metric"
import { useResponseHandle } from "../../hooks"

const resourceBudgetAPI = new ResourceBudgetAPI()
const metricAPI = new MetricAPI()

export const getYears = async (params: any) => {
  const { token, navigate, dispatch, loading, office } = params

  if (token) {
    loading(true)
    const response = await resourceBudgetAPI.getAvailableBudgetYears({
      token,
      practiceSk: office?.practice_sk,
    })

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let tempYears: any = []

        result?.data?.forEach((year: any) => {
          tempYears.push({ label: year })
        })

        // Sort years in descending order (most recent first)
        tempYears.sort((a: any, b: any) => {
          const yearA = parseInt(a.label)
          const yearB = parseInt(b.label)
          return yearB - yearA
        })

        dispatch([...tempYears])
      }
      loading(false)
    } else {
      loading(false)
      navigate("/auth")
    }
  }
  loading(false)
}

export const getYearsIndependent = async (params: any) => {
  const { token, navigate, dispatch, loading, group } = params

  if (token) {
    loading(true)
    const response = await metricAPI.getAllAvailableYears(
      token,
      group?.group_sk,
    )

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        let tempYears: any = []

        result?.data?.forEach((year: any) => {
          tempYears.push({ label: year.year })
        })

        // Sort years in descending order (most recent first)
        tempYears.sort((a: any, b: any) => {
          const yearA = parseInt(a.label)
          const yearB = parseInt(b.label)
          return yearB - yearA
        })

        dispatch([...tempYears])
      }
      loading(false)
    } else {
      loading(false)
      navigate("/auth")
    }
  }
  loading(false)
}
